export default [
    // 承运商账号
    {
        path: "carrieraccount/list",
        name: "carrierAccount",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/index"),
    },
    {
        path: "carrieraccount/update/:type",
        name: "CarrierAccountUpdate",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/update.vue"),
    },
    // 承运商Shipping账号
    {
        path: "carrieraccount/shippingaccount/list",
        name: "ShippingAccount",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/shippingaccount/index")
    },
    // 承运商Billing账号
    {
        path: "carrieraccount/billingaccount/list",
        name: "BillingAccount",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/billingaccount/index")
    },
    // 客户承运商黑名单
    {
        path: "carrieraccount/blackaccount/list",
        name: "BlackAccount",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/blackaccount/index")
    },
    {
        path: "carrieraccount/carrierservice/list",
        name: "CarrierService",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/carrierservice/index")
    },
    {
        path: "carrieraccount/warehousecarrier/list",
        name: "WarehouseCarrier",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/warehousecarrier/index")
    },
    // 物流测算列表
    {
        path: "carrieraccount/logisticmeasure/list",
        name: "Logisticmeasure",
        component: () => import(/* webpackChunkName: "carrieraccount" */ "@/views/carrieraccount/logisticmeasure/index")
    },
]